// music-player.js — 音乐播放器公共组件（单例）
// 容器无关，通过 MusicPlayer.init(containerEl, options) 挂载到任意容器
// <audio> 元素挂载到 document.body，与 UI 容器解耦

var _instance = null;
var _cssLoaded = false;

// 按需加载播放器样式（首屏不阻塞）
function _ensureMusicPlayerCSS() {
  if (_cssLoaded) return;
  _cssLoaded = true;
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/story-writer/css/shared/music-player.css';
  document.head.appendChild(link);
}

// SVG 图标集
var ICONS = {
  play: '<svg viewBox="0 0 200 200"><path d="M152.2,96.4L78,36.3c-3-2.5-7.5-0.3-7.5,3.6v120.2c0,3.9,4.5,6,7.5,3.6l74.3-60.1C154.5,101.7,154.5,98.3,152.2,96.4z"/></svg>',
  pause: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 200 200"><path d="M70.5,163.87a11,11,0,0,1-11-11V47.13a11,11,0,1,1,22,0V152.87A11,11,0,0,1,70.5,163.87Z" fill="#fff"/><path d="M129.5,163.87a11,11,0,0,1-11-11V47.13a11,11,0,1,1,22,0V152.87A11,11,0,0,1,129.5,163.87Z" fill="#fff"/></svg>',
  prev: '<svg viewBox="0 0 200 200"><path d="M160.6,170.9l-71.3-57.7c-8.4-6.8-8.4-19.6,0-26.4l71.3-57.7" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/><line x1="39.4" y1="31.3" x2="39.4" y2="166.5" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round"/></svg>',
  next: '<svg viewBox="0 0 200 200"><path d="M39.4,29.1l71.3,57.7c8.4,6.8,8.4,19.6,0,26.4l-71.3,57.7" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/><line x1="160.6" y1="168.7" x2="160.6" y2="33.5" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round"/></svg>',
  loop_seq: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 200 200"><path d="M100,197.8A97.8,97.8,0,1,1,190.11,61.93a10,10,0,1,1-18.42,7.79,77.82,77.82,0,1,0,2.8,52.76l-1.35,1a10,10,0,0,1-12-16L181.8,92a10,10,0,0,1,16,8A97.91,97.91,0,0,1,100,197.8Z" fill="currentColor"/><path d="M132.27,88.5H67.73a10,10,0,0,1,0-20h64.54a10,10,0,0,1,0,20Z" fill="currentColor"/><path d="M132.27,131.5H67.73a10,10,0,0,1,0-20h64.54a10,10,0,0,1,0,20Z" fill="currentColor"/></svg>',
  loop_single: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 200 200"><path d="M80.6,82.2c0,0,12.5-3.9,21.1-18.5v72.5" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/><path d="M180.9,65.8c-13.3-31.5-44.5-53.6-80.9-53.6c-48.5,0-87.8,39.3-87.8,87.8s39.3,87.8,87.8,87.8s87.8-39.3,87.8-87.8l-20.7,15.5" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  loop_shuffle: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 200 200"><path d="M19.33,35.71H35.47a63.45,63.45,0,0,1,25.22,5.11A65,65,0,0,1,81.55,55.05a77.66,77.66,0,0,0-8.06,15.14A48.33,48.33,0,0,0,56.78,56.71a47.56,47.56,0,0,0-21.3-4.93H19.34a8.06,8.06,0,0,1-8.07-8,7.71,7.71,0,0,1,2.36-5.68,7.78,7.78,0,0,1,5.71-2.36h0Zm129.09,80.38a7.92,7.92,0,0,1,5.74,2.38l32.27,32.16a7.79,7.79,0,0,1,2.33,5.7,7.67,7.67,0,0,1-2.33,5.65l-32.27,32.16a8.2,8.2,0,0,1-11.45,0,7.62,7.62,0,0,1-2.36-5.66,8.05,8.05,0,0,1,2.32-5.7l18.53-18.46H148.41a63.35,63.35,0,0,1-25.21-5.09,64.94,64.94,0,0,1-20.87-14.18,77.7,77.7,0,0,0,8.06-15.14,48.37,48.37,0,0,0,16.69,13.42,47.32,47.32,0,0,0,21.33,4.91H161.2l-18.53-18.41a7.94,7.94,0,0,1-2.33-5.7,8.07,8.07,0,0,1,8.07-8Zm0-112.53A7.83,7.83,0,0,1,154.16,6l32.27,32.12a8.12,8.12,0,0,1,0,11.39L154.16,81.6a8.1,8.1,0,0,1-13.81-5.7,8,8,0,0,1,2.32-5.66L161.2,51.78H148.41a47.3,47.3,0,0,0-21.3,4.93A48.59,48.59,0,0,0,110.4,70.16,47,47,0,0,0,100,100a62.67,62.67,0,0,1-8.06,31.14A63,63,0,0,1,81.54,145a64.55,64.55,0,0,1-20.87,14.21,63.9,63.9,0,0,1-25.22,5.06H19.32a7.75,7.75,0,0,1-5.71-2.36,7.66,7.66,0,0,1-2.37-5.68,7.78,7.78,0,0,1,2.37-5.68,7.87,7.87,0,0,1,5.71-2.36H35.45a47.12,47.12,0,0,0,21.34-4.9,47.9,47.9,0,0,0,16.68-13.42A47,47,0,0,0,83.86,100a62.57,62.57,0,0,1,8.07-31.14A61.83,61.83,0,0,1,102.33,55a64.73,64.73,0,0,1,20.87-14.2,62.89,62.89,0,0,1,25.21-5.15H161.2L142.67,17.3a8.05,8.05,0,0,1-2.32-5.7,7.81,7.81,0,0,1,2.36-5.71,7.9,7.9,0,0,1,5.71-2.36v0Z" fill="currentColor"/></svg>',
  // 歌词模式：音符图标
  lyric: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 200 200"><line x1="31.3" y1="31.1" x2="49" y2="31.1" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round"/><polyline points="31.3,69.3 46.6,69.3 46.6,168.9 61.8,168.9" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/><polyline points="87.1,32.1 168.7,32.1 168.7,168.9 136.9,168.9" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/><line x1="87.1" y1="61.8" x2="133.2" y2="61.8" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round"/><rect x="87.1" y="92.3" width="46.1" height="49.6" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  // 歌词模式：麦克风图标
  mic: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 200 200"><path d="M100,3.5a8.78,8.78,0,0,1,0,17.55,78.9,78.9,0,1,0,68.5,39.66A8.77,8.77,0,1,1,183.71,52h0A96.51,96.51,0,1,1,100,3.5Zm43.86,0a26.32,26.32,0,0,1,26.32,26.32,8.77,8.77,0,0,1-17.48,1l-.06-1a8.78,8.78,0,0,0-17.49-1l-.06,1V100a35.1,35.1,0,1,1-17.54-30.39V29.82A26.31,26.31,0,0,1,143.86,3.5ZM100,82.45A17.55,17.55,0,0,0,117.55,100,17.55,17.55,0,0,0,100,82.45Z" fill="currentColor"/></svg>'
};

function MusicPlayerInstance() {
  var self = this;
  self._audio = null;         // <audio> 元素（挂载到 document.body）
  self._container = null;     // 宿主容器（可为 null）
  self._dom = {};             // DOM 引用
  self._context = 'sidebar';  // 'sidebar' | 'editor'
  self._mode = 'sequential';  // 'sequential' | 'shuffle' | 'single'
  self._playlist = [];        // [{ recordId, songName, library, fileToken, lyrics }]
  self._currentIndex = -1;
  self._currentRecordId = null;
  self._isPlaying = false;
  self._isDragging = false;   // 进度条拖拽中
  self._shuffledList = [];    // 随机模式下的打乱列表
  self._inited = false;
  // LRC 歌词
  self._lyrics = [];          // [{ time, text }]
  self._lyricsLoaded = false;
  // localStorage 保存防抖
  self._saveTimer = null;
  // 歌词模式
  self._lyricMode = false;
  self._lyricText = '';
  self._lyricMarqueeTimer = null;
  self._lyricMarqueeOffset = 0;
  self._modeUserSet = false;   // 用户是否手动设置过播放模式
  self._toastTimer = null;     // toast 自动消失定时器
}

var MP = MusicPlayerInstance.prototype;

// ===== 公共 API =====

MP.init = function(containerEl, options) {
  options = options || {};
  _ensureMusicPlayerCSS();
  // 重入：更新 context，若 context 变化则重新挂载 UI 到对应容器
  if (this._inited) {
    var prevContext = this._context;
    if (options.context) this._context = options.context;
    if (prevContext !== this._context) {
      // 清除残留的 toast 定时器，防止切换页面后弹出旧提示
      if (this._toastTimer) { clearTimeout(this._toastTimer); this._toastTimer = null; }
      if (this._dom.toastEl) this._dom.toastEl.classList.remove('music-player__toast--visible');

      if (this._context === 'editor') {
        // 切换到编辑器上下文：强制重置为单曲循环
        this._mode = 'single';
        this._modeUserSet = false;
        this._applyMode();
      } else if (this._context === 'sidebar') {
        // 切换回侧边栏上下文：恢复用户之前保存的侧边栏模式偏好
        try {
          var raw = localStorage.getItem('music_player_sidebar_mode');
          if (raw) {
            var saved = JSON.parse(raw);
            if (saved && saved._modeUserSet) {
              this._mode = saved.mode || 'sequential';
              this._modeUserSet = true;
              this._applyMode();
            } else {
              // 有保存记录但用户未手动设定过模式 → 使用默认
              this._mode = 'sequential';
              this._modeUserSet = false;
              this._applyMode();
            }
          } else {
            // 无任何保存记录 → 使用默认顺序播放
            this._mode = 'sequential';
            this._modeUserSet = false;
            this._applyMode();
          }
        } catch(e) {
          // localStorage 读取异常时也回退到默认
          this._mode = 'sequential';
          this._modeUserSet = false;
          this._applyMode();
        }
      }
      if (this._dom.root) {
        this._remountToContext();
      }
    }
    return;
  }

  this._ensureAudio();
  this._bindAudioEvents();
  this._context = options.context || 'sidebar';
  this._buildUI();
  this._applyMode();
  this._inited = true;
  this._tryRestoreFromStorage();
  if (this._dom.root) this._updateLyricBtnState();
  this._registerSessionSave();
};

MP.play = function(recordId, options) {
  options = options || {};

  // 上下文/播放列表更新
  if (options.context) this._context = options.context;
  if (options.playlist) {
    this._playlist = options.playlist;

    // 仅在用户从未手动设置过模式时，才应用默认模式
    if (!this._modeUserSet) {
      if (this._context === 'editor' && options.defaultMode == null) {
        this._mode = 'single';
      } else if (options.defaultMode) {
        this._mode = options.defaultMode;
      } else if (this._context === 'sidebar') {
        this._mode = 'sequential';
      }
    }
    this._shuffledList = [];
    this._applyMode();
  }
  if (options.defaultMode && !this._modeUserSet) {
    this._mode = options.defaultMode;
    this._applyMode();
  }

  // 同一曲目：toggle 播放/暂停
  if (recordId === this._currentRecordId && this._audio) {
    // 播放列表可能已更新，同步当前曲目索引
    if (options.playlist) {
      this._currentIndex = -1;
      for (var k = 0; k < this._playlist.length; k++) {
        if (this._playlist[k].recordId === this._currentRecordId) {
          this._currentIndex = k;
          break;
        }
      }
    }
    if (this._isPlaying) {
      this._audio.pause();
    } else {
      this._audio.play().catch(function(e) {
        console.warn('[music-player] 播放失败:', e.message);
      });
    }
    return;
  }

  // 不同曲目：找到索引并播放
  var idx = -1;
  var list = this._mode === 'shuffle' && this._shuffledList.length > 0
    ? this._shuffledList : this._playlist;
  for (var i = 0; i < list.length; i++) {
    if (list[i].recordId === recordId) { idx = i; break; }
  }
  if (idx === -1 && list.length > 0) idx = 0;
  if (idx === -1) return;

  this._currentIndex = idx;
  this._currentRecordId = list[idx].recordId;
  this._loadAndPlay(list[idx]);
};

// 获取当前播放 recordId，供外部同步状态（music-block 按钮图标切换等）
MP.getCurrentRecordId = function() {
  return this._currentRecordId;
};

// 更新播放列表（面板刷新/上传后同步，不影响当前播放进度）
MP.updatePlaylist = function(newItems) {
  if (!newItems || !Array.isArray(newItems)) return;
  var playlist = newItems.map(function(r) {
    return { recordId: r.recordId, songName: r.songName, library: r.library, fileToken: r.fileToken, lyrics: r.lyrics || '' };
  });
  // 保留当前播放位置
  var idx = -1;
  if (this._currentRecordId) {
    for (var i = 0; i < playlist.length; i++) {
      if (playlist[i].recordId === this._currentRecordId) { idx = i; break; }
    }
  }
  this._playlist = playlist;
  this._currentIndex = idx >= 0 ? idx : -1;
};

// 获取播放状态
MP.isPlaying = function() {
  return this._isPlaying;
};

// 获取当前歌名
MP.getCurrentSongName = function() {
  var list = this._getActiveList();
  for (var i = 0; i < list.length; i++) {
    if (list[i].recordId === this._currentRecordId) return list[i].songName || '';
  }
  // fallback: 从 DOM 获取（仅限非歌词模式）
  if (!this._lyricMode && this._dom.nameEl) return this._dom.nameEl.textContent || '';
  return '';
};

// 获取 <audio> 元素引用
MP.getAudio = function() {
  return this._audio;
};

// 获取当前播放模式
MP.getMode = function() {
  return this._mode;
};

// 销毁（保留 audio，仅清理 UI 容器）
MP.destroy = function() {
  if (this._saveTimer) { clearTimeout(this._saveTimer); this._saveTimer = null; }
  if (this._lyricMarqueeTimer) { clearInterval(this._lyricMarqueeTimer); this._lyricMarqueeTimer = null; }
  if (this._toastTimer) { clearTimeout(this._toastTimer); this._toastTimer = null; }
  if (this._dom.toastEl) { this._dom.toastEl.remove(); this._dom.toastEl = null; }
  var c = this._resolveContainer();
  if (c) c.innerHTML = '';
  this._dom = {};
  this._inited = false;
};

// 完全销毁（含 audio 元素移除）
MP.destroyAll = function() {
  if (this._audio) {
    this._audio.pause();
    this._audio.src = '';
    this._audio.remove();
    this._audio = null;
  }
  if (this._saveTimer) { clearTimeout(this._saveTimer); this._saveTimer = null; }
  if (this._lyricMarqueeTimer) { clearInterval(this._lyricMarqueeTimer); this._lyricMarqueeTimer = null; }
  if (this._toastTimer) { clearTimeout(this._toastTimer); this._toastTimer = null; }
  if (this._dom.toastEl) { this._dom.toastEl.remove(); this._dom.toastEl = null; }
  var c = this._resolveContainer();
  if (c) c.innerHTML = '';
  this._dom = {};
  this._playlist = [];
  this._shuffledList = [];
  this._currentIndex = -1;
  this._currentRecordId = null;
  this._isPlaying = false;
  this._isDragging = false;
  this._inited = false;
  this._lyrics = [];
  this._lyricsLoaded = false;
  this._lyricMode = false;
  this._lyricText = '';
  this._lyricMarqueeOffset = 0;
};

// ===== UI 容器重新挂载 =====

MP.remount = function(containerEl) {
  if (!this._inited) return;
  // UI 尚未构建 → 首次挂载到解析容器
  if (!this._dom.root) {
    this._buildUI();
    this._applyMode();
    if (this._isPlaying && this._dom.playBtn) {
      this._dom.playBtn.innerHTML = ICONS.pause;
      this._dom.root.classList.add('music-player--playing');
    }
    // 恢复歌词状态
    if (this._lyricMode) {
      if (this._lyricMarqueeTimer) { clearInterval(this._lyricMarqueeTimer); this._lyricMarqueeTimer = null; }
      if (this._dom.lyricBtn) {
        this._dom.lyricBtn.innerHTML = ICONS.mic;
        this._dom.lyricBtn.title = '退出歌词';
      }
      if (this._dom.prevBtn) this._dom.prevBtn.style.display = 'none';
      if (this._dom.nextBtn) this._dom.nextBtn.style.display = 'none';
      if (this._dom.modeBtn) this._dom.modeBtn.style.display = 'none';
      if (this._dom.nameEl) this._dom.nameEl.classList.add('music-player__song-name--lyric');
      this._lyricText = '';
      this._updateLyricDisplay();
    }
    return;
  }
  // UI 已在 #globalPlayer 中，无需移动
};

// ===== 确保 <audio> 元素存在 =====

MP._ensureAudio = function() {
  if (this._audio) return;
  var audio = document.createElement('audio');
  audio.preload = 'auto';
  audio.style.display = 'none';
  document.body.appendChild(audio);
  this._audio = audio;
};

// ===== 容器解析（根据 context 选择挂载目标） =====

MP._resolveContainer = function() {
  if (this._context === 'sidebar') {
    var panelContainer = document.querySelector('.sidebar-panel .music-player-container');
    if (panelContainer) return panelContainer;
  }
  var gp = document.getElementById('globalPlayer');
  if (!gp) {
    gp = document.createElement('div');
    gp.id = 'globalPlayer';
    gp.style.display = 'none';
    document.body.appendChild(gp);
  }
  return gp;
};

MP._remountToContext = function() {
  var target = this._resolveContainer();
  var root = this._dom.root;
  if (!target || !root) return;
  if (root.parentNode === target) return; // 已在正确容器中
  target.innerHTML = '';
  target.appendChild(root);
};

// ===== UI 构建 =====

MP._buildUI = function() {
  var c = this._resolveContainer();
  if (!c) return;
  c.innerHTML = '';

  // 播放器根容器
  var root = document.createElement('div');
  root.className = 'music-player';

  // 进度条（顶部贴边，全宽）
  var progressWrapper = document.createElement('div');
  progressWrapper.className = 'music-player__progress-wrapper';

  var progressTrack = document.createElement('div');
  progressTrack.className = 'music-player__progress-track';
  progressWrapper.appendChild(progressTrack);

  var progressBar = document.createElement('div');
  progressBar.className = 'music-player__progress-bar';
  progressBar.style.width = '0%';

  var progressThumb = document.createElement('div');
  progressThumb.className = 'music-player__progress-thumb';
  progressBar.appendChild(progressThumb);

  progressWrapper.appendChild(progressBar);
  root.appendChild(progressWrapper);

  // 播放按钮 + 主区域行容器
  var row = document.createElement('div');
  row.className = 'music-player__row';

  // 播放按钮
  var playBtn = document.createElement('button');
  playBtn.type = 'button';
  playBtn.className = 'music-player__play-btn';
  playBtn.innerHTML = ICONS.play;
  row.appendChild(playBtn);

  // 主区域
  var main = document.createElement('div');
  main.className = 'music-player__main';

  // 信息行
  var info = document.createElement('div');
  info.className = 'music-player__info';

  var nameEl = document.createElement('span');
  nameEl.className = 'music-player__song-name';
  nameEl.textContent = '';
  info.appendChild(nameEl);

  // 控制按钮组
  var controls = document.createElement('div');
  controls.className = 'music-player__controls';

  var prevBtn = document.createElement('button');
  prevBtn.type = 'button';
  prevBtn.className = 'music-player__btn music-player__btn--prev';
  prevBtn.innerHTML = ICONS.prev;
  prevBtn.title = '上一首';
  controls.appendChild(prevBtn);

  var nextBtn = document.createElement('button');
  nextBtn.type = 'button';
  nextBtn.className = 'music-player__btn music-player__btn--next';
  nextBtn.innerHTML = ICONS.next;
  nextBtn.title = '下一首';
  controls.appendChild(nextBtn);

  var modeBtn = document.createElement('button');
  modeBtn.type = 'button';
  modeBtn.className = 'music-player__btn music-player__btn--mode';
  modeBtn.innerHTML = ICONS.loop_seq;
  modeBtn.title = '切换播放模式';
  controls.appendChild(modeBtn);

  // 歌词模式按钮
  var lyricBtn = document.createElement('button');
  lyricBtn.type = 'button';
  lyricBtn.className = 'music-player__btn music-player__btn--lyric';
  lyricBtn.innerHTML = ICONS.lyric;
  lyricBtn.title = '歌词模式';
  lyricBtn.disabled = true;
  controls.appendChild(lyricBtn);

  info.appendChild(controls);
  main.appendChild(info);

  row.appendChild(main);
  root.appendChild(row);

  // toast 浮层提示（挂到 body，确保容器隐藏时也能显示）
  var toastEl = document.createElement('div');
  toastEl.className = 'music-player__toast';
  document.body.appendChild(toastEl);

  c.appendChild(root);

  // 保存 DOM 引用
  this._dom = {
    root: root,
    playBtn: playBtn,
    nameEl: nameEl,
    prevBtn: prevBtn,
    nextBtn: nextBtn,
    modeBtn: modeBtn,
    lyricBtn: lyricBtn,
    progressWrapper: progressWrapper,
    progressBar: progressBar,
    progressThumb: progressThumb,
    toastEl: toastEl
  };

  this._bindUIEvents();
};

// ===== 事件绑定（音频事件） =====

MP._bindAudioEvents = function() {
  var self = this;
  var audio = self._audio;
  if (!audio) return;

  audio.addEventListener('loadedmetadata', function() {
    if (self._dom.progressBar) self._updateProgress();
  });

  audio.addEventListener('timeupdate', function() {
    if (self._dom.progressBar) self._updateProgress();
    if (self._lyricMode) self._updateLyricDisplay();
    self._emitState();
  });

  audio.addEventListener('ended', function() {
    self._onEnded();
  });

  audio.addEventListener('play', function() {
    console.debug('[music-player] 事件 play: paused=' + audio.paused + ' src=' + (audio.currentSrc || audio.src || '(空)'));
    self._isPlaying = true;
    if (self._dom.playBtn) self._dom.playBtn.innerHTML = ICONS.pause;
    if (self._dom.root) self._dom.root.classList.add('music-player--playing');
    if (self._lyricMode) self._startLyricMarquee();
    self._emitState();
  });

  audio.addEventListener('pause', function() {
    console.debug('[music-player] 事件 pause: paused=' + audio.paused);
    self._isPlaying = false;
    if (self._dom.playBtn) self._dom.playBtn.innerHTML = ICONS.play;
    if (self._dom.root) self._dom.root.classList.remove('music-player--playing');
    if (self._lyricMarqueeTimer) { clearInterval(self._lyricMarqueeTimer); self._lyricMarqueeTimer = null; }
    self._emitState();
  });

  audio.addEventListener('error', function(e) {
    var err = audio.error;
    var errInfo = err ? ('code=' + err.code + ' message=' + (err.message || '(空)')) : '无 MediaError 对象';
    console.error('[music-player] 音频加载失败, src=' + (audio.src || '(空)') + ' MediaError: ' + errInfo);
    // MediaError 代码: 1=MEDIA_ERR_ABORTED, 2=MEDIA_ERR_NETWORK, 3=MEDIA_ERR_DECODE, 4=MEDIA_ERR_SRC_NOT_SUPPORTED
    self._isPlaying = false;
    if (self._dom.playBtn) self._dom.playBtn.innerHTML = ICONS.play;
    if (self._dom.root) self._dom.root.classList.remove('music-player--playing');
  });
};

// ===== 事件绑定（UI 交互） =====

MP._bindUIEvents = function() {
  var self = this;
  var audio = self._audio;
  var dom = self._dom;
  if (!dom.root) return;

  // 播放/暂停按钮
  dom.playBtn.addEventListener('click', function() {
    if (self._isPlaying) {
      audio.pause();
    } else {
      if (audio.src) {
        audio.play().catch(function(e) {
          console.warn('[music-player] 播放失败:', e.message);
        });
      } else if (self._playlist.length > 0) {
        self.play(self._playlist[0].recordId);
      }
    }
  });

  // 上一首
  dom.prevBtn.addEventListener('click', function() {
    self._prev();
  });

  // 下一首
  dom.nextBtn.addEventListener('click', function() {
    self._next();
  });

  // 模式切换
  dom.modeBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    self._cycleMode();
  });

  // 歌词模式切换
  dom.lyricBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    self._toggleLyricMode();
  });

  // 进度条拖拽/点击
  var dragRatio = 0;

  function getRatio(e) {
    var rect = dom.progressWrapper.getBoundingClientRect();
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var ratio = (clientX - rect.left) / rect.width;
    return Math.max(0, Math.min(1, ratio));
  }

  function setProgressUI(ratio) {
    dom.progressBar.style.width = (ratio * 100) + '%';
  }

  dom.progressWrapper.addEventListener('mousedown', function(e) {
    if (!audio.duration || isNaN(audio.duration)) return;
    self._isDragging = true;
    dragRatio = getRatio(e);
    setProgressUI(dragRatio);
    e.preventDefault();
  });

  dom.progressWrapper.addEventListener('touchstart', function(e) {
    if (!audio.duration || isNaN(audio.duration)) return;
    self._isDragging = true;
    dragRatio = getRatio(e);
    setProgressUI(dragRatio);
    e.preventDefault();
  });

  document.addEventListener('mousemove', function(e) {
    if (!self._isDragging) return;
    dragRatio = getRatio(e);
    setProgressUI(dragRatio);
  });

  document.addEventListener('touchmove', function(e) {
    if (!self._isDragging) return;
    dragRatio = getRatio(e);
    setProgressUI(dragRatio);
  });

  function endDrag() {
    if (!self._isDragging) return;
    self._isDragging = false;
    audio.currentTime = dragRatio * audio.duration;
  }

  document.addEventListener('mouseup', endDrag);
  document.addEventListener('touchend', endDrag);
};

// ===== 播放逻辑 =====

MP._loadAndPlay = function(record) {
  var self = this;
  var audio = self._audio;

  if (!record || !record.fileToken) return;

  var streamUrl = '/api/files/music-stream/' + encodeURIComponent(record.fileToken) +
    '?type=' + (record.library === '项目' ? 'project' : 'reference');

  // 直接使用服务器 URL，让 Chrome 通过 Range 请求正常解析 MP3
  audio.removeAttribute('src');
  audio.src = streamUrl;

  if (self._dom.nameEl && !self._lyricMode) self._dom.nameEl.textContent = record.songName || '';
  if (self._dom.progressBar) self._dom.progressBar.style.width = '0%';

  self._currentRecordId = record.recordId;

  // 加载歌词
  if (record.lyrics) {
    self._setLyrics(record.lyrics);
  } else {
    self._setLyrics('');
  }

  // 更新歌词按钮状态（歌词模式下由 _enterLyricMode 管理，不覆盖）
  if (!self._lyricMode) self._updateLyricBtnState();
  // 歌词模式下立即更新歌词文字
  if (self._lyricMode) self._updateLyricDisplay();

  audio.load();
  audio.play().catch(function(e) {
    console.warn('[music-player] 播放失败:', e.message);
  });

  self._scheduleSave();
};

MP._prev = function() {
  var list = this._getActiveList();
  if (list.length === 0) return;
  var idx = this._currentIndex - 1;
  if (idx < 0) idx = list.length - 1;
  this._currentIndex = idx;
  this._loadAndPlay(list[idx]);
};

MP._next = function() {
  var list = this._getActiveList();
  if (list.length === 0) return;
  var idx = this._currentIndex + 1;
  if (idx >= list.length) idx = 0;
  this._currentIndex = idx;
  this._loadAndPlay(list[idx]);
};

MP._onEnded = function() {
  if (this._mode === 'single') {
    // 单曲循环：重播当前曲目
    this._audio.currentTime = 0;
    this._audio.play().catch(function() {});
  } else {
    this._next();
  }
};

MP._seek = function(percent) {
  var audio = this._audio;
  if (audio && audio.duration) {
    audio.currentTime = (percent / 100) * audio.duration;
  }
};

MP._getActiveList = function() {
  if (this._mode === 'shuffle' && this._shuffledList.length > 0) {
    return this._shuffledList;
  }
  return this._playlist;
};

// ===== 模式管理 =====

MP._cycleMode = function() {
  var map = { sequential: 'single', single: 'shuffle', shuffle: 'sequential' };
  this._mode = map[this._mode] || 'sequential';
  this._modeUserSet = true;
  this._applyMode();
  this._emitStateNow();   // 立即同步触发，不经过防抖
  this._showToast(this._getModeLabel());  // 弹出模式提示
  this._scheduleSave();
};

MP._applyMode = function() {
  var dom = this._dom;
  if (!dom.modeBtn) return;
  // 更新图标
  if (this._mode === 'single') {
    dom.modeBtn.innerHTML = ICONS.loop_single;
    dom.modeBtn.title = '单曲循环';
  } else if (this._mode === 'shuffle') {
    dom.modeBtn.innerHTML = ICONS.loop_shuffle;
    dom.modeBtn.title = '随机播放';
    // 仅在无已恢复状态时才生成新洗牌列表
    if (!this._shuffledList || this._shuffledList.length === 0) {
      this._shuffleList();
    }
  } else {
    dom.modeBtn.innerHTML = ICONS.loop_seq;
    dom.modeBtn.title = '列表顺序';
  }
};

MP._shuffleList = function() {
  var list = this._playlist.slice();
  for (var i = list.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = list[i];
    list[i] = list[j];
    list[j] = temp;
  }
  this._shuffledList = list;
};

// ===== 进度条 =====

MP._updateProgress = function() {
  if (this._isDragging) return;
  var audio = this._audio;
  if (!audio.duration || isNaN(audio.duration)) return;
  var bar = this._dom.progressBar;
  if (!bar) return;
  var pct = (audio.currentTime / audio.duration) * 100;
  bar.style.width = pct + '%';
};

// ===== LRC 歌词 =====

MP._parseLRC = function(lrcText) {
  var lines = [];
  if (!lrcText) return lines;
  var rawLines = lrcText.split(/\r?\n/);
  var timeTagRe = /\[(\d{1,2}):(\d{2})(?:\.(\d{1,3}))?\]/g;

  for (var i = 0; i < rawLines.length; i++) {
    var line = rawLines[i];
    var match;
    var times = [];
    timeTagRe.lastIndex = 0;

    while ((match = timeTagRe.exec(line)) !== null) {
      var min = parseInt(match[1], 10);
      var sec = parseInt(match[2], 10);
      var ms = match[3] ? parseInt(match[3], 10) : 0;
      if (match[3] && match[3].length === 2) ms *= 10; // 百分秒 → 毫秒
      times.push(min * 60 + sec + ms / 1000);
    }

    var text = line.replace(timeTagRe, '').trim();
    // 跳过纯元数据标签（[ti:], [ar:], [al:], [by:], [offset:] 等）
    if (times.length === 0 && text.length === 0) continue;
    if (times.length === 0 && /^\[[a-z]+:/.test(line)) continue;

    for (var t = 0; t < times.length; t++) {
      lines.push({ time: times[t], text: text });
    }
  }

  // 按时间排序
  lines.sort(function(a, b) { return a.time - b.time; });
  return lines;
};

MP._setLyrics = function(lrcText) {
  if (lrcText && lrcText.trim()) {
    this._lyrics = this._parseLRC(lrcText);
    this._lyricsLoaded = true;
  } else {
    this._lyrics = [];
    this._lyricsLoaded = false;
  }
};

MP._getCurrentLyric = function() {
  if (!this._lyricsLoaded || this._lyrics.length === 0) return '';
  var audio = this._audio;
  if (!audio) return '';
  var currentTime = audio.currentTime || 0;

  for (var i = this._lyrics.length - 1; i >= 0; i--) {
    if (currentTime >= this._lyrics[i].time) {
      return this._lyrics[i].text;
    }
  }
  return '';
};

// 获取当前歌词（公开）
MP.getCurrentLyric = function() {
  return this._getCurrentLyric();
};

// 是否有歌词
MP.hasLyrics = function() {
  return this._lyricsLoaded && this._lyrics.length > 0;
};

// ===== 状态广播 =====

MP._emitState = function() {
  var self = this;
  if (self._emitTimer_) clearTimeout(self._emitTimer_);
  self._emitTimer_ = setTimeout(function() {
    self._emitStateNow();
    self._emitTimer_ = null;
  }, 200);
};

MP._emitStateNow = function() {
  if (this._emitTimer_) {
    clearTimeout(this._emitTimer_);
    this._emitTimer_ = null;
  }
  try {
    if (typeof window !== 'undefined' && window.dispatchEvent) {
      var audio = this._audio;
      window.dispatchEvent(new CustomEvent('musicplayer:statechange', {
        detail: {
          recordId: this._currentRecordId,
          isPlaying: this._isPlaying,
          context: this._context,
          mode: this._mode,
          songName: this.getCurrentSongName(),
          currentTime: audio ? audio.currentTime : 0,
          duration: audio ? (audio.duration || 0) : 0
        }
      }));
    }
  } catch(e) {}
};

MP._getModeLabel = function() {
  if (this._mode === 'single') return '单曲循环';
  if (this._mode === 'shuffle') return '随机播放';
  return '顺序播放';
};

MP._showToast = function(message) {
  var toast = this._dom.toastEl;
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('music-player__toast--visible');
  if (this._toastTimer) clearTimeout(this._toastTimer);
  this._toastTimer = setTimeout(function() {
    toast.classList.remove('music-player__toast--visible');
  }, 2000);
};

// ===== localStorage 保存/恢复 =====

MP._scheduleSave = function() {
  var self = this;
  if (self._saveTimer) clearTimeout(self._saveTimer);
  self._saveTimer = setTimeout(function() {
    self._saveToStorage();
  }, 500);
};

MP._saveToStorage = function() {
  if (!this._currentRecordId) return;
  var state = {
    isPlaying: this._isPlaying,
    currentIndex: this._currentIndex,
    currentRecordId: this._currentRecordId,
    mode: this._mode,
    _modeUserSet: this._modeUserSet,
    context: this._context,
    currentTime: this._audio ? this._audio.currentTime : 0,
    savedAt: Date.now(),
    playlist: this._playlist.map(function(item) {
      return { recordId: item.recordId, songName: item.songName, library: item.library, fileToken: item.fileToken, lyrics: item.lyrics || '' };
    }),
    shuffledList: this._shuffledList ? this._shuffledList.slice() : null
  };
  try {
    localStorage.setItem('music_player_state', JSON.stringify(state));
  } catch (e) {
    console.warn('[music-player] localStorage 保存失败:', e.message);
  }
  // 侧边栏模式偏好独立存储（不被 editor 渠道覆盖）
  if (this._context === 'sidebar') {
    try {
      localStorage.setItem('music_player_sidebar_mode', JSON.stringify({
        mode: this._mode,
        _modeUserSet: this._modeUserSet
      }));
    } catch(e) {}
  }
};

MP._tryRestoreFromStorage = function() {
  var self = this;
  try {
    var raw = localStorage.getItem('music_player_state');
    if (!raw) return;
    var state = JSON.parse(raw);
    if (!state || !state.playlist || state.playlist.length === 0) return;

    self._playlist = state.playlist;
    self._mode = state.mode || 'sequential';
    self._modeUserSet = state._modeUserSet || false;
    // 如果是 editor 上下文，强制重置为单曲循环（编辑器模式不持久化）
    if (self._context === 'editor') {
      self._mode = 'single';
      self._modeUserSet = false;
    }
    self._context = state.context || 'sidebar';
    if (state.mode === 'shuffle') {
      self._shuffledList = state.shuffledList || null;
    }
    self._applyMode();

    // 恢复当前曲目
    var record;
    if (state.mode === 'shuffle' && self._shuffledList && self._shuffledList.length > state.currentIndex) {
      record = self._shuffledList[state.currentIndex];
    } else {
      record = state.playlist[state.currentIndex];
    }
    if (record && record.fileToken) {
      self._currentIndex = state.currentIndex;
      self._currentRecordId = record.recordId;

      if (self._dom.nameEl && !self._lyricMode) self._dom.nameEl.textContent = record.songName || '';
      if (record.lyrics) {
        self._setLyrics(record.lyrics);
      }
      // 同步 UI：播放中显示暂停图标，暂停显示播放图标
      if (self._dom.playBtn) {
        self._dom.playBtn.innerHTML = state.isPlaying ? ICONS.pause : ICONS.play;
      }
      if (self._dom.root) {
        if (state.isPlaying) {
          self._dom.root.classList.add('music-player--playing');
        } else {
          self._dom.root.classList.remove('music-player--playing');
        }
      }

      // 直接使用服务器 URL（不经过 Blob），让 Chrome 通过 Range 请求正常解析 MP3
      var audio = self._audio;
      audio.removeAttribute('src');
      audio.src = '/api/files/music-stream/' + encodeURIComponent(record.fileToken) +
        '?type=' + (record.library === '项目' ? 'project' : 'reference');
      audio.currentTime = state.currentTime || 0;
      if (state.isPlaying) {
        audio.play().catch(function() {});
      }
    }
  } catch (e) {
    console.warn('[music-player] localStorage 恢复失败:', e.message);
  }
};

MP._registerSessionSave = function() {
  var self = this;
  var handler = function() {
    if (self._saveTimer) { clearTimeout(self._saveTimer); self._saveTimer = null; }
    if (self._lyricMode) self._exitLyricMode();
    self._saveToStorage();
  };
  window.addEventListener('pagehide', handler);
  window.addEventListener('beforeunload', handler);
};

// ===== 歌词模式 =====

MP._toggleLyricMode = function() {
  if (this._lyricMode) {
    this._exitLyricMode();
  } else if (this.hasLyrics()) {
    this._enterLyricMode();
  }
};

MP._enterLyricMode = function() {
  this._lyricMode = true;
  if (this._dom.lyricBtn) {
    this._dom.lyricBtn.innerHTML = ICONS.mic;
    this._dom.lyricBtn.title = '退出歌词';
  }
  // 隐藏 prev, next, mode 按钮
  if (this._dom.prevBtn) this._dom.prevBtn.style.display = 'none';
  if (this._dom.nextBtn) this._dom.nextBtn.style.display = 'none';
  if (this._dom.modeBtn) this._dom.modeBtn.style.display = 'none';
  // 歌名区域切换为歌词模式样式
  if (this._dom.nameEl) this._dom.nameEl.classList.add('music-player__song-name--lyric');
  // 歌词模式：用 .music-player__song-name 显示歌词
  this._updateLyricDisplay();
  if (this._isPlaying) this._startLyricMarquee();
};

MP._exitLyricMode = function() {
  this._lyricMode = false;
  if (this._dom.lyricBtn) {
    this._dom.lyricBtn.innerHTML = ICONS.lyric;
  }
  // 恢复 prev, next, mode 按钮
  if (this._dom.prevBtn) this._dom.prevBtn.style.display = '';
  if (this._dom.nextBtn) this._dom.nextBtn.style.display = '';
  if (this._dom.modeBtn) this._dom.modeBtn.style.display = '';
  // 恢复歌名区域
  if (this._dom.nameEl) {
    this._dom.nameEl.classList.remove('music-player__song-name--lyric');
    this._dom.nameEl.textContent = this.getCurrentSongName() || '';
    this._dom.nameEl.style.transform = '';
  }
  if (this._lyricMarqueeTimer) {
    clearInterval(this._lyricMarqueeTimer);
    this._lyricMarqueeTimer = null;
  }
  this._lyricMarqueeOffset = 0;
  this._updateLyricBtnState();
};

MP._updateLyricBtnState = function() {
  if (!this._dom.lyricBtn) return;
  var hasLyrics = this.hasLyrics();
  this._dom.lyricBtn.disabled = !hasLyrics;
  if (hasLyrics) {
    this._dom.lyricBtn.title = '歌词模式';
  } else {
    this._dom.lyricBtn.title = '无歌词';
  }
};

MP._updateLyricDisplay = function() {
  if (!this._lyricMode) return;
  if (!this._dom.nameEl) return;
  var text = this._getCurrentLyric();
  if (text === this._lyricText) return;
  this._lyricText = text;
  this._dom.nameEl.textContent = text || ' ';
  // 重置跑马灯
  if (this._lyricMarqueeTimer) {
    clearInterval(this._lyricMarqueeTimer);
    this._lyricMarqueeTimer = null;
  }
  this._lyricMarqueeOffset = 0;
  this._dom.nameEl.style.transform = 'translateX(0)';
  if (this._isPlaying && text) {
    this._startLyricMarquee();
  }
};

MP._startLyricMarquee = function() {
  var self = this;
  if (!self._lyricMode) return;
  if (!self._dom.nameEl) return;
  if (self._lyricMarqueeTimer) return; // already running

  var textEl = self._dom.nameEl;
  var textWidth = textEl.scrollWidth;
  var containerWidth = textEl.clientWidth;

  if (textWidth <= containerWidth) {
    // 文字不超出容器，不需要跑马灯
    textEl.style.transform = 'translateX(0)';
    return;
  }

  var scrollDistance = textWidth - containerWidth;
  var step = 1; // 每帧移动 1px
  var interval = 30; // ~33fps

  self._lyricMarqueeTimer = setInterval(function() {
    self._lyricMarqueeOffset += step;
    if (self._lyricMarqueeOffset >= scrollDistance + 120) {
      // 到头后暂停 3 秒再重置（120 帧 ≈ 3.6s @33ms）
      self._lyricMarqueeOffset = scrollDistance + 120;
      textEl.style.transform = 'translateX(' + (-scrollDistance) + 'px)';
      clearInterval(self._lyricMarqueeTimer);
      self._lyricMarqueeTimer = null;
      // 暂停后重启
      setTimeout(function() {
        if (!self._lyricMode || !self._isPlaying) return;
        self._lyricMarqueeOffset = 0;
        textEl.style.transform = 'translateX(0)';
        self._startLyricMarquee();
      }, 3000);
      return;
    }
    var offset = Math.min(self._lyricMarqueeOffset, scrollDistance);
    textEl.style.transform = 'translateX(' + (-offset) + 'px)';
  }, interval);
};

// ===== 导出单例 =====

export var MusicPlayer = {
  init: function(containerEl, options) {
    if (!_instance) {
      _instance = new MusicPlayerInstance();
    }
    _instance.init(containerEl, options);
    return _instance;
  },

  play: function(recordId, options) {
    if (!_instance) { console.warn('[MusicPlayer] 未初始化'); return; }
    _instance.play(recordId, options);
  },

  prev: function() {
    if (!_instance) return;
    _instance._prev();
  },

  next: function() {
    if (!_instance) return;
    _instance._next();
  },

  cycleMode: function() {
    if (!_instance) return;
    _instance._cycleMode();
  },

  seek: function(percent) {
    if (!_instance) return;
    _instance._seek(percent);
  },

  getCurrentSongName: function() {
    return _instance ? _instance.getCurrentSongName() : '';
  },

  getCurrentRecordId: function() {
    return _instance ? _instance.getCurrentRecordId() : null;
  },

  isPlaying: function() {
    return _instance ? _instance.isPlaying() : false;
  },

  getAudio: function() {
    return _instance ? _instance.getAudio() : null;
  },

  getMode: function() {
    return _instance ? _instance.getMode() : 'sequential';
  },

  updatePlaylist: function(newItems) {
    if (!_instance) return;
    _instance.updatePlaylist(newItems);
  },

  isInited: function() {
    return !!_instance && _instance._inited;
  },

  remount: function(containerEl) {
    if (_instance) _instance.remount(containerEl);
  },

  setLyrics: function(lrcText) {
    if (_instance) _instance._setLyrics(lrcText);
  },

  getCurrentLyric: function() {
    return _instance ? _instance.getCurrentLyric() : '';
  },

  hasLyrics: function() {
    return _instance ? _instance.hasLyrics() : false;
  },

  toggleLyricMode: function() {
    if (_instance) _instance._toggleLyricMode();
  },

  isLyricMode: function() {
    return _instance ? _instance._lyricMode : false;
  },

  destroy: function() {
    if (_instance) {
      _instance.destroy();
      _instance = null;
    }
  }
};
